import { createSelector } from 'reselect';
import { getEntities } from '../../global-selectors';
import { get } from '../../utils/lodash';

export const selectMsoConfig = createSelector(
  getEntities,
  entities => get(entities, 'msoConfig', {}),
)
